import { injectGlobal } from 'vue-styled-components';
import theme from '@/config/theme';

injectGlobal([
  `
  * {
    border: 0;
    margin: 0;
    outline: none;
    padding: 0;

    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;

    -webkit-font-smoothing: antialiased;
  }

  html, body {
    height: 100%;
  }

  body {
    background-color: ${theme.colors.grayBg};
    font-family: ${theme.font.family}
    font-size: 16px;
  }

  @font-face {
    font-family: ${theme.font.family};
    font-style: normal;
    font-weight: ${theme.font.regular};
    font-display: swap;
    src: local(''),
    url('/fonts/ProximaNovaRegular.woff2') format('woff2');
  }

  @font-face {
    font-family: ${theme.font.family};
    font-style: normal;
    font-weight: ${theme.font.bold};
    font-display: swap;
    src: local(''),
    url('/fonts/ProximaNovaBold.woff2') format('woff2');
  }

  a {
    cursor: pointer;
    text-decoration: none;
  }

  h1, h2, h4, h5, h6 {
    font-weight: ${theme.font.regular};
  }

  h3 {
    font-weight: ${theme.font.bold};
  }

  h1 {
    font-size: ${theme.font.sizes.h1};
    line-height: ${theme.font.lineHeights.h1};
  }

  h2 {
    font-size: ${theme.font.sizes.h2};
    line-height: ${theme.font.lineHeights.h2};
  }

  h3 {
    font-size: ${theme.font.sizes.h3};
    line-height: ${theme.font.lineHeights.h3};
  }

  h4 {
    font-size: ${theme.font.sizes.h4};
    line-height: ${theme.font.lineHeights.h4};
  }

  h5 {
    font-size: ${theme.font.sizes.h5};
    line-height: ${theme.font.lineHeights.h5};
  }

  h6 {
    font-size: ${theme.font.sizes.h6};
    line-height: ${theme.font.lineHeights.h6};
  }

  input, button {
    font-family: ${theme.font.family};
  }

  // BEGIN: SCROLLBAR

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.gray3};
    border-radius: ${theme.border.radius.small};
    width: 12px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray4};
    border-radius: ${theme.border.radius.small};
  }

  // END: SCROLLBAR

  .wrapper-page {
    min-height: 100%;
    padding-bottom: 158px;
    position: relative;
  }

  // BEGIN: CONTAINER

  .container {
    margin: 0 auto;
    width: 90%;

    @media screen and (min-width: ${theme.grid.mobile.breakpoint}) {
      width: ${theme.grid.mobile.container};
    }

    @media screen and (min-width: ${theme.grid.tablet.breakpoint}) {
      width: ${theme.grid.tablet.container};
    }

    @media screen and (min-width: ${theme.grid.xltablet.breakpoint}) {
      width: ${theme.grid.xltablet.container};

      &.md {
        width: 1024px;
      }
    }

    @media screen and (min-width: ${theme.grid.desktop.breakpoint}) {
      width: ${theme.grid.desktop.container};
    }

    @media screen and (min-width: ${theme.grid.xldesktop.breakpoint}) {
      width: ${theme.grid.xldesktop.container};
    }

    @media screen and (max-width: ${theme.grid.tablet.breakpoint}) {
      .treePath {
        display: none;
      }
    }

    // END: CONTAINER
  }

  .loading-placeholder {
    background: linear-gradient(to right, #F3F3F3 10%, #EEE 30%, #F3F3F3 50%);
    background-color: #F3F3F3;
    display: block;
    border-radius: 5px;

    animation-name: loading-placeholder;
    animation-duration: 2s;
    animation-delay: 0s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    height: 20px;
    width: 100px;
  }

  @keyframes loading-placeholder {
    100% {
      background-position-x: 100px
    }
  }
`,
]);
